import React, { useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { hybridLayoutDataModel } from '../utils/DataModel';
import { HybridContentfulWidgets } from '../components/HybridContentfulWidgets';
import {
  validateNValue,
  isRefinedPage,
  getPathName
} from '../utils/utils';
import { useHybridPLP } from '../hooks/useHybridPLP';

const HybridContentfulWidgetComposable = () => {
  const ctx = useContext(ExperienceContext);
  const { customer, customContext } = ctx;
  const { variables = {}, hybridLoading, isHybridLayout, pageType } = customContext || {};
  const isShowProducts = !!variables?.additionalSearchParams?.plp;
  const isSearch = pageType === 'search';
  const isBrowse = pageType === 'browse';
  const slugData = validateNValue(variables?.navParam) ? variables?.navParam : `N-${variables?.navParam}`;
  const pathname = getPathName(ctx.path ?? '');
  const customerType = customer?.type;
  const { instance } = useContext(AppContext);

  const hybridParams = {
    slug: slugData,
    customerType,
    instance,
    isShowProducts,
    storeId: variables?.storeId,
    skip: isSearch || isRefinedPage(pathname) || !variables?.navParam,
  };
  const { contentElements } = useHybridPLP(hybridParams);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('hybrid.ready');
  }, []);

  return (
    <>
      {isHybridLayout && !hybridLoading && isBrowse && (
        <HybridContentfulWidgets
          contentElements={contentElements}
          loading={hybridLoading}
          isBrowse={isBrowse}
        />
      )}
    </>
  );
};

HybridContentfulWidgetComposable.propTypes = {};

HybridContentfulWidgetComposable.defaultProps = {};

HybridContentfulWidgetComposable.displayName = 'HybridContentfulWidgetComposable';

HybridContentfulWidgetComposable.dataModel = hybridLayoutDataModel;

export { HybridContentfulWidgetComposable };
